import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AttributeOptionDraft = {
  id?: number | string;
  title: string;
  code: string;
};

export type AttributeFormDraft = {
  name: string;
  description: string;
  options: AttributeOptionDraft[];
};

const emptyFormDraft = (): AttributeFormDraft => ({
  name: '',
  description: '',
  options: [],
});

export interface FarmAttributeFormsState {
  edit: {
    attributeId: number | string | null;
    form: AttributeFormDraft;
    version: number;
    dirty: boolean;
  };
}

const initialState: FarmAttributeFormsState = {
  edit: {
    attributeId: null,
    form: emptyFormDraft(),
    version: 0,
    dirty: false,
  },
};

const cloneForm = (form: AttributeFormDraft): AttributeFormDraft => ({
  name: form.name,
  description: form.description,
  options: form.options.map((option) => ({
    id: option.id,
    title: option.title,
    code: option.code,
  })),
});

const farmAttributeFormsSlice = createSlice({
  name: 'farmAttributeForms',
  initialState,
  reducers: {
    setEditDraft: (
      state,
      action: PayloadAction<{ attributeId: number | string | null; form: AttributeFormDraft }>,
    ) => {
      state.edit.attributeId = action.payload.attributeId;
      state.edit.form = cloneForm(action.payload.form);
      state.edit.version += 1;
      state.edit.dirty = false;
    },
    updateEditDraft: (state, action: PayloadAction<AttributeFormDraft>) => {
      state.edit.form = cloneForm(action.payload);
      state.edit.dirty = true;
    },
    resetEditDraft: (state) => {
      state.edit.attributeId = null;
      state.edit.form = emptyFormDraft();
      state.edit.version = 0;
      state.edit.dirty = false;
    },
  },
});

export const { setEditDraft, updateEditDraft, resetEditDraft } = farmAttributeFormsSlice.actions;

export default farmAttributeFormsSlice.reducer;
